export interface IPackageCardData {
    id: string
    pic: string
    title: string
    goldenLabel: string
    dollarAmount: string
    KMONAmount: string
    BNBAmount: string
}

export const ALL_PACKAGES = (): IPackageCardData[] => {
    return [
        {
            id: 'coins_0',
            pic: './assets/img/Icon/coins_0.png',
            title: 'KMON PACKAGE',
            goldenLabel: '2.4k', //will be overwrite
            dollarAmount: '$19.99',
            KMONAmount: '2.4k', //will be overwrite
            BNBAmount: '0.02'//will be overwrite
        },
        {
            id: 'coins_1',
            pic: './assets/img/Icon/coins_1.png',
            title: 'KMON PACKAGE',
            goldenLabel: 'asdk', //will be overwrite
            dollarAmount: '$39.99',
            KMONAmount: 'asdk', //will be overwrite
            BNBAmount: 'asd'//will be overwrite
        },
        {
            id: 'coins_2',
            pic: './assets/img/Icon/coins_2.png',
            title: 'KMON PACKAGE',
            goldenLabel: '8.79k', //will be overwrite
            dollarAmount: '$59.99',
            KMONAmount: '8.79k', //will be overwrite
            BNBAmount: '0.02'//will be overwrite
        }
    ]
}